import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { MfaModel } from '@models/mfa.model';
import { MfaActions } from '@states/mfa/mfa.action-types';


export interface UserMfaState extends EntityState<MfaModel.Document> {
  isInitialLoaded: boolean;
}

export const adapter: EntityAdapter<MfaModel.Document> = createEntityAdapter<MfaModel.Document>({
  selectId: (document: MfaModel.Document) => document.id,
});


const initialState: UserMfaState = adapter.getInitialState({
  isInitialLoaded: false,
});

export const userMfaStateReducer = createReducer(
  initialState,
  on(MfaActions.resetToInitialState, () => {
    return {
      ...initialState,
    };
  }),
  on(MfaActions.getUserMfaMethodsSuccess, (state, { documents }) => {
    return adapter.setAll(documents, {
      ...state,
      isInitialLoaded: true,
    });
  }),
  on(MfaActions.getUserMfaMethodsFail, (state) => {
    return {
      ...state,
      isInitialLoaded: true,
    };
  }),
);
